<h1 mat-dialog-title>
    {{ data.title }}
</h1>

<div mat-dialog-content>
    <table class="notes">
        <thead>
            <td style="width:30%;padding-left: 1vw;">{{'Caller' | translate}}</td>
            <td style="width:30%;padding-left: 1vw;" *ngIf="!data.caseId">{{'Case' | translate}}</td>
            <td style="width:20%;padding-left: 1vw;">{{'Communication' | translate}}</td>
            <td style="width:20%;padding-left: 1vw;">{{'Type' | translate}}</td>
            <td style="width:10%;padding-left: 1vw;">{{'Date' | translate}}</td>
        </thead>
        <tbody>
            <tr style="text-align: center;" *ngIf="logsList.length == 0">
                <td colspan="3">{{'No records found' | translate}}</td>
            </tr>
            <tr *ngFor="let note of logsList;let noteIndex = index" class="note">
                <td>

                    <span class="nameAlone">{{note.initiatedFrom.name}}</span>
                </td>
                <td *ngIf="!data.caseId">
                    <div class="borderContent">
                        <span class="nameAlone">{{note.case?.name || '-'}}</span>
                    </div>
                </td>
                <td class="skip">
                    <div class="borderContent">
                        <div fxLayout="row" fxLayoutAlign="start center">
                            <ng-container *ngIf="!note.initiatedFrom?._id">
                                <!-- <span class="center">L1</span> -->
                                <span *ngIf="!(note.createdUser?._id)" class="center">L1</span>
                                <span *ngIf="note.createdUser?._id" class="center">{{note.createdUser?.name}}</span>
                                <ng-container *ngIf="note.investigators?.length || note.investigatorgroup?.length">
                                    <img src="assets/images/double-arrow.png" style="width: 1.4vw; margin: 0 0.2vw;" />
                                    <div fxLayout="column" fxLayoutGap="1vh" class="recepients">
                                        <div fxFlex *ngFor="let investigator of note.investigators">
                                            <span>{{investigator.alternative_name
                                                ?
                                                investigator.alternative_name: investigator.name}}</span>
                                        </div>
                                        <div fxFlex *ngFor="let group of note.investigatorgroup">
                                            <span>{{group.name}}</span>
                                        </div>
                                    </div>
                                </ng-container>
                            </ng-container>
                            <ng-container *ngIf="note.initiatedFrom?._id">
                                <div class="recepients">
                                    <span>{{note.initiatedFrom.name}}</span>
                                </div>
                                <img src="assets/images/double-arrow.png" style="width: 1.4vw; margin: 0 0.2vw;" />
                                <span *ngIf="!(note.investigators?.length || note.investigatorgroup?.length)"
                                    class="center">L1</span>
                                <ng-container *ngIf="note.investigators?.length || note.investigatorgroup?.length">
                                    <div fxLayout="column" fxLayoutGap="1vh" class="recepients">
                                        <div fxFlex *ngFor="let investigator of note.investigators">
                                            <span>{{investigator.alternative_name
                                                ?
                                                investigator.alternative_name: investigator.name}}</span>
                                        </div>
                                        <div fxFlex *ngFor="let group of note.investigatorgroup">
                                            <span>{{group.name}}</span>
                                        </div>
                                    </div>
                                </ng-container>
                            </ng-container>
                        </div>
                    </div>
                </td>
                <td class="skip">
                    <div class="borderContent">
                        {{note.type == 'missedcall' ? ('Missed call' | translate): ('Call' | translate)}}
                    </div>
                </td>
                <td class="skip">
                    <div class="borderContent">
                        <div fxLayout="column" fxGrow="0" fxLayoutAlign="center">
                            <span fxFlex class="date" fxGrow="0"
                                [class.updated]="note.updatedAt != note.createdAt">{{note.updatedAt
                                | date: "yyyy/MM/dd"}}</span>
                            <span fxFlex class="time" fxGrow="0"
                                [class.updated]="note.updatedAt != note.createdAt">{{note.updatedAt
                                | date: "H:mm"}}</span>
                        </div>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
    <mat-paginator [pageSizeOptions]="[5,10,20,30]" showFirstLastButtons class="paginator-shadow"
        (page)="fetchLogs($event)" [pageIndex]="pageIndex" [pageSize]="pageSize">
    </mat-paginator>
</div>
<div mat-dialog-actions>
    <div fxLayout="row" fxLayoutGap="1vh" fxLayoutAlign="center center">
        <div fxFlex align="right">
            <button class="red-text" mat-raised-button mat-dialog-close (click)="closeModal()">
                {{ "Close" | translate }}
            </button>
        </div>
    </div>
</div>